import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { hasTaskDescription } from './taskCardUtils';
import { looksLikeHtml, toDisplayableRichTextHtml, toRichTextEditorValue } from '../../helpers/safeHtml';

const TaskDescriptionClamp = ({ task, className = '', style }) => {
  const descRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);

  const hasDescription = hasTaskDescription(task);

  useEffect(() => {
    setExpanded(false);
  }, [task?._id, task?.description]);

  // Remeasure after layout — grouped view mounts inside Bootstrap Collapse,
  // so the first paint often has height 0 and would hide "See more".
  useLayoutEffect(() => {
    if (!hasDescription || expanded) {
      setCanExpand(false);
      return undefined;
    }

    const el = descRef.current;
    if (!el) return undefined;

    const measure = () => {
      if (!descRef.current) return;
      setCanExpand(descRef.current.scrollHeight > descRef.current.clientHeight + 1);
    };

    measure();
    const rafId = requestAnimationFrame(measure);
    const observer = new ResizeObserver(measure);
    observer.observe(el);

    return () => {
      cancelAnimationFrame(rafId);
      observer.disconnect();
    };
  }, [hasDescription, expanded, task?.description]);

  if (!hasDescription) return null;

  return (
    <div
      className={`mt-1 text-muted smallFont ${className}`.trim()}
      style={{ minWidth: 0, wordBreak: 'break-word', ...style }}
      onClick={e => e.stopPropagation()}
    >
      <div
        ref={descRef}
        className={`task-desc-clamp__body${
          expanded ? ' is-expanded scrollbar-thin' : ' is-clamped'
        }`}
        dangerouslySetInnerHTML={{
          __html: toDisplayableRichTextHtml(
            looksLikeHtml(task.description) ? task.description : toRichTextEditorValue(task.description)
          )
        }}
      />
      {(canExpand || expanded) && (
        <button
          type="button"
          className="task-desc-clamp__toggle"
          onClick={() => setExpanded(open => !open)}
        >
          {expanded ? 'See less' : 'See more'}
        </button>
      )}
    </div>
  );
};

export default TaskDescriptionClamp;
